import React, { useEffect, useState, useMemo } from 'react';
import PropTypes from 'prop-types';
import { Field, reduxForm, change } from 'redux-form';
import { Col, Row } from 'reactstrap';
import renderSelectField from 'src/shared/components/form/Select';
import { connect, useSelector, useDispatch } from 'react-redux';
import MerchantCustomerDetails from './MerchantCustomerDetails';
import renderToggleButtonField from 'src/shared/components/form/ToggleButton';

const required = value => value ? undefined : 'Required';

const MerchantPickUp = ({ dropOffRequiredLaterValue, isCustomersId, isMerchantPickUpPoint, isInfo }) => {
    const dispatch = useDispatch();
    const [isDropOffRequiredLater, setDropOffRequiredLater] = useState(false);
    const [selectedPickUpPoint, setSelectedPickUpPoint] = useState(null);

    const formOrderFromAddressType = useSelector(
        state => state.form?.orderForm?.values?.orderFromAddressTypeInfo
    );

    useEffect(() => {
        if (isInfo?.dropOffRequiredLater) {
            setDropOffRequiredLater(true);
        }
    }, [isInfo]);

    // Check if "Merchant Customer" is selected in "Pick Up From"
    const isMerchantCustomer = useMemo(() => {
        const current = selectedPickUpPoint || formOrderFromAddressType;
        if (current) {
            if (current.value === 0 || current.label === "Merchant Customer" || current.value === 5) {
                return true;
            }
        }
        if (isInfo) {
            const orderFromTypeId = Number(
                isInfo?.orderFromAddressTypeInfo?.orderAddressTypeId ??
                isInfo?.orderFromAddressTypeId ??
                isInfo?.fromAddressTypeId
            );
            if (orderFromTypeId === 5 || isInfo?.fromUniqueId === 5) {
                return true;
            }
            if (isInfo?.orderFromAddressTypeInfo?.value === 0 || isInfo?.orderFromAddressTypeInfo?.label === "Merchant Customer") {
                return true;
            }
            if (!isInfo?.collectionPointId && (isInfo?.name || isInfo?.address || isInfo?.shortCode || isInfo?.contactNo)) {
                return true;
            }
        }
        return false;
    }, [selectedPickUpPoint, formOrderFromAddressType, isInfo]);

    const handlePickUpPointChange = (event, val) => {
        const selected = val || event;
        setSelectedPickUpPoint(selected);
        const isCustomer = selected?.value === 0 || selected?.label === "Merchant Customer";
        if (isCustomer) {
            setDropOffRequiredLater(false);
            dispatch(change('orderForm', 'dropOffRequiredLater', false));
        }
    };

    const getDropOffRequiredLater = (events) => {
        setDropOffRequiredLater(!!events);
    };

    return (
        <>
            <Row className="g-2 mb-3">
                <Col lg={isMerchantCustomer ? 6 : 4} md={6}>
                    <div className="mb-1">
                        <label className="form-label fw-bold text-muted small mb-0" style={{ fontSize: '0.75rem' }}>
                            Pick Up From <span className='text-danger'>*</span>
                        </label>
                        <Field
                            validate={[required]}
                            name="orderFromAddressTypeInfo"
                            component={renderSelectField}
                            options={isMerchantPickUpPoint}
                            placeholder="Select Pick Up Point"
                            isDisabled={!!isInfo?.orderNo}
                            onChange={(event, val) => handlePickUpPointChange(event, val)}
                        />
                    </div>
                </Col>

                {!isMerchantCustomer && isInfo && isInfo?.collectionPointId && (
                    <Col lg={4} md={6}>
                        <div className="mb-1">
                            <label className="form-label fw-bold text-muted small mb-0" style={{ fontSize: '0.75rem' }}>
                                Pick Up Location <span className='text-danger'>*</span>
                            </label>
                            <Field
                                validate={[required]}
                                name="collectionPointId"
                                component={renderSelectField}
                                options={isMerchantPickUpPoint}
                                placeholder="Select Pick Up Point"
                                isDisabled={!!isInfo?.orderNo}
                            />
                        </div>
                    </Col>
                )}

                {/* "Drop Off Required Later?" is ONLY shown when picking up from a Collection Point, NOT when picking up from a Merchant Customer */}
                {!isMerchantCustomer && (
                    <Col lg={4} md={6}>
                        <div className="mb-1">
                            <label className="form-label fw-bold text-muted small mb-0" style={{ fontSize: '0.75rem' }}>
                                Drop Off Required Later?
                            </label>
                            <div className="mt-1">
                                <Field
                                    name="dropOffRequiredLater"
                                    component={renderToggleButtonField}
                                    onChange={getDropOffRequiredLater}
                                    defaultChecked={dropOffRequiredLaterValue}
                                />
                            </div>
                        </div>
                    </Col>
                )}
            </Row>

            {/* When picking up from Merchant Customer, Customer Details MUST show immediately. 
                For Collection Points, Customer Details shows if Drop Off Required Later is toggled ON. */}
            {(isMerchantCustomer || (!isMerchantCustomer && isDropOffRequiredLater)) && (
                <MerchantCustomerDetails isCustomersId={isCustomersId} />
            )}
        </>
    );
};

MerchantPickUp.propTypes = {
    dropOffRequiredLaterValue: PropTypes.bool,
    isCustomersId: PropTypes.array,
    isMerchantPickUpPoint: PropTypes.array,
    isInfo: PropTypes.object,
};

export default connect()(reduxForm({
    form: "orderForm",
    enableReinitialize: true,
    destroyOnUnmount: false,
    forceUnregisterOnUnmount: false,
})(MerchantPickUp));
